import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Hotjar from '@hotjar/browser';

import { releaseFlags } from '../../helpers/featuresFlags/featuresFlags';
import { usePrevious } from '../hooks';
import { GeneralActionCreators } from '../redux/actions/creators';
import { MeSelectors } from '../redux/selectors';

function checkRedirects(route, location, me, accessToken) {
  const redirects = [
    function redirectRootPath() {
      if (location.pathname === '/') {
        return <Navigate to={{ pathname: '/login' }} state={{ from: location }} replace />;
      }
      return null;
    },
    function redirectAuthUser() {
      const prePrivatePaths = [
        '/login',
        '/forgot-password',
        '/password-setup/:token',
        '/password-reset/:token',
        '/ask-new-invitation/:token',
        '/ask-new-invitation/reset/:token',
      ];
      if (
        accessToken
        && me._id
        && me.isActive
        && prePrivatePaths.includes(route.path)
      ) {
        const defaultPrivateRoute = me.allowedPageRoutes.find(r => r.isDefault || r.isFallback);
        return <Navigate to={{ pathname: defaultPrivateRoute.path }} state={{ from: location }} replace />;
      }
      return null;
    },
    function redirectNotEnabledPath() {
      const isRouteEnabled = !releaseFlags.isFlaggingEnabled || !releaseFlags[me.role]?.[route.path.split('/')[1]]?.isDisabled;
      if (!isRouteEnabled) {
        return <Navigate to={{ pathname: '/not-found' }} state={{ from: location }} replace />;
      }
      return null;
    },
  ];

  let redirect;
  redirects.some((func) => {
    redirect = func();
    return redirect;
  });

  return redirect;
}

const PublicRoute = (props) => {
  const { route, children } = props;
  const dispatch = useDispatch();
  const location = useLocation();
  const me = useSelector(MeSelectors.selectMe);
  const accessToken = localStorage.getItem('accessToken');

  useEffect(() => {
    if (Hotjar.isReady()) {
      Hotjar.stateChange(location.pathname);
    }
  }, [location.pathname]);

  // TODO: DEPRECATED
  const prevPath = usePrevious(route.path);
  if (prevPath !== route.path) {
    dispatch(GeneralActionCreators.resetStore());
  }

  const redirect = checkRedirects(route, location, me, accessToken);
  if (redirect) return redirect;

  return children;
};

export default PublicRoute;
